import { checkOptions } from "../utils";

export * from "./input";
export * from "./select";
export * from "./validators";

import DuoRadio from "./DuoRadio.vue";
import HasError from "./directives/has-error.directive";
import ErrorMessage from "./directives/error-message.directive";
import UploadFile from "./UploadFile.vue";

export const HcDuoRadio = DuoRadio;
export const HcUploadFile = UploadFile;

export const FormPlugin = {
  install
};

function install(Vue, options = {}) {
  options = checkOptions(options);

  Vue.directive(HasError.name, HasError);
  Vue.directive(ErrorMessage.name, ErrorMessage);
}
